module.exports = __webpack_public_path__ + "img/kids.47216f63.png";